// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SysAdminSettings_sectionTitle__ILN59","sysAdminBorderBottom":"SysAdminSettings_sysAdminBorderBottom__ElROv"};